import React from 'react';
import './../styles/dashboard.css';

const AppSystemTrackDataGrid = ({ data }) => {
    const statusClass = data.Status === 'Error' ? 'status-error' : 'status-success';
    return (
        <div className="grid-container">
            <div className="grid-item"><strong>APP System:</strong> {data.APP_system}</div>
            <div className="grid-item"><strong>Tracking Time:</strong> {new Date(data["Tracking time"]).toLocaleString()}</div>
            <div className="grid-item"><strong>Status:</strong> <span className={statusClass}>{data.Status}</span></div>
            <div className="grid-item"><strong>System Created Time:</strong> {data.systemCreatedTime}</div>
            <div className="grid-item"><strong>Job Unid:</strong> {data.JOB_UNID || 'N/A'}</div>
            <div className="grid-item"><strong>Station:</strong> {data.STATION}</div>
            <div className="grid-item"><strong>GSHP ID:</strong> {data.GSHPID || 'N/A'}</div>
            <div className="grid-item"><strong>Biz Type:</strong> {data.BIZTYPE}</div>
            <div className="grid-item"><strong>Shp Type:</strong> {data.SHPTYPE || 'N/A'}</div>
            <div className="grid-item"><strong>Additional Comment:</strong> {data.AdditionalComment}</div>
        </div>
    );
}

export default AppSystemTrackDataGrid;
